let ConstantDraw = {

    Style_KeyPos: {
        pixelSize: 10,
        color: Cesium.Color.TURQUOISE,
        outlineColor: Cesium.Color.YELLOW,
        outlineWidth: 2,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        disableDepthTestDistance: Number.MAX_VALUE,
    },
    Style_CenterPos: {
        pixelSize: 10,
        color: Cesium.Color.DARKKHAKI,
        outlineColor: Cesium.Color.DARKRED,
        outlineWidth: 2,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        disableDepthTestDistance: Number.MAX_VALUE,
    },
    Style_RotationPos: {
        pixelSize: 10,
        color: Cesium.Color.DARKKHAKI,
        outlineColor: Cesium.Color.DARKVIOLET,
        outlineWidth: 2,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        disableDepthTestDistance: Number.MAX_VALUE,
    },

    Style_LineNor: {
        show: true,
        material: Cesium.Color.RED,
        width: 3,
        clampToGround: true,
        disableDepthTestDistance: Number.MAX_VALUE,
    },
    Style_PolygonNor: {
        clampToGround: true,
        show: true,
        fill: true,
        material: Cesium.Color.RED.withAlpha(0.5),
        width: 3,
        outlineColor: Cesium.Color.RED,
        outlineWidth: 2,
        outline: true,
        disableDepthTestDistance: Number.MAX_VALUE,
    },
    Style_CicleNor: {
        material: Cesium.Color.RED.withAlpha(0.5),
        outline: true,
        disableDepthTestDistance: Number.MAX_VALUE,
    },
    Style_RectangleNor: {
        material: Cesium.Color.RED.withAlpha(0.5),
        rotation: 0,
        stRotation: 0,
        disableDepthTestDistance: Number.MAX_VALUE,
    },
    Style_Billboard: {
        scale: 1,
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        disableDepthTestDistance: Number.MAX_VALUE
    },

    //https://cesium.com/learn/cesiumjs/ref-doc/LabelGraphics.html#.ConstructorOptions
    Style_Label: {
        text: '文本',
        font: '16px sans-serif',
        style: Cesium.LabelStyle.FILL,
        showBackground: true,
        backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
        pixelOffset: new Cesium.Cartesian2(0.0, -40.0),
        outlineWidth: 1,
        fillColor: Cesium.Color.WHITE,
        horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
        disableDepthTestDistance: Number.MAX_VALUE,
        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND,
    }
}

export default ConstantDraw;